import { Report } from '@cims-online/shared'

export const PDFDesignLayerType = {
  AsphaltMaterial: {
    name: 'Asphalt Material',
    names: 'Asphalt Materials',
    featureServerId: 45,
    reports: [Report.AsphaltCoreSheet, Report.AsphaltLot],
    previewTypes: ['AsphaltPlacement'],
  },
  DailyInspectionWorkType: {
    name: 'Work Type',
    names: 'Work Types',
    featureServerId: 31,
    reports: [Report.Inspection, Report.ControlPoint, Report.PunchList],
    previewTypes: [
      'DailyInspectionControlPoint',
      'DailyInspectionPunchList',
      'DailyInspectionInspection',
    ],
  },
  MaterialRequirement: {
    name: 'Material Requirement',
    names: 'Material Requirements',
    featureServerId: 8,
    reports: [Report.DensityLot],
    previewTypes: ['Lot'],
  },
  ConcreteMaterial: {
    name: 'Concrete Material',
    names: 'Concrete Materials',
    featureServerId: 18,
    reports: [Report.ConcreteTestSet, Report.ConcretePlacementCoreSheet],
    previewTypes: ['ConcretePlacement'],
  },
} as const
